import React from "react";
import Education from "./Education";

function ExperienceList() {
  return (
    <div className="mt-[40px]">
      <Education
        title={"MERN Stack Developer"}
        subTitle={"Coding Shuttle"}
        date={"2022 - 2023"}
      />
      <Education
        title={"Product Designer"}
        subTitle={"Capstone Project - Patiala"}
        date={"2021 - 2022"}
        reverse={"flex-row-reverse"}
      />
      <Education
        title={"Machine Learning Enthusiast"}
        subTitle={"Thapar University - Patiala"}
        date={"2021"}
        height={"h-0"}
      />
    </div>
  );
}

export default ExperienceList;
